import type { ModelId } from 'chat-shared'

const STORAGE_KEY = 'chat.preferredModel'

/**
 * Liest das zuletzt gewählte Modell aus dem localStorage. Der Katalog ist
 * DB-verwaltet — ob das Modell (noch) existiert, prüfen Aufrufer gegen die
 * geladene /api/models-Liste. Liefert undefined, wenn nichts gespeichert
 * oder localStorage nicht verfügbar ist.
 */
export const readPreferredModel = (): ModelId | undefined => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY)
    return value ?? undefined
  } catch {
    // localStorage nicht verfügbar (z.B. blockiert) – dann gibt es keine Präferenz
    return undefined
  }
}

/**
 * Merkt sich das gewählte Modell im localStorage, damit die Auswahl
 * über Chats und Browser-Sessions hinweg bestehen bleibt.
 */
export const storePreferredModel = (model: ModelId): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, model)
  } catch {
    // localStorage nicht verfügbar – Auswahl gilt dann nur für die aktuelle Session
  }
}
